<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-card-text>
                    <v-treeview
                        v-model="selected"
                        :active.sync="active"
                        :open.sync="open"
                        activatable
                        :items="organizational_charts"
                        color="teal"
                        selected-color="teal"
                        selection-type="independent"
                        return-object
                        open-all
                        hoverable
                        @update:active="save"
                    >
                        <template v-slot:prepend="{ open }">
                            <v-icon>
                                {{ open ? "mdi-folder-open" : "mdi-folder" }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-text-field
            :value="label_text"
            :label="label"
            prepend-inner-icon="mdi-circle-double"
            readonly
            :color="inputColor"
            outlined
            :background-color="backgroundColor"
            :clearable="!readonly"
            :loading="loading"
            @click:clear="clear"
            dense
            open-all
            hide-details="auto"
            :rules="rules"
            @click="dialog = true"
        ></v-text-field>
        <input type="hidden"/>
    </div>
</template>

<script>
import axios from "axios";
import useSharedData from "@/use/SharedData";
import {computed, onMounted, ref} from "vue";

export default {
    props: {
        value: Number,
        label: String,
        rules: Array,
        readonly: Boolean,
    },
    emits: ["input", "change"],
    setup(props, {emit}) {
        const {
            inputColor,
            backgroundColor,
            loading,
        } = useSharedData();

        const dialog = ref(false);
        const organizational_chart = ref(null);
        const organizational_charts = ref([]);
        const all_records = ref([]);
        const active = ref([]);
        const open = ref([]);
        const selected = ref([]);

        const label_text = computed(() => {
            let obj = all_records.value.filter((v) => v.id === props.value)[0];
            if (obj) {
                return obj.name;
            }
            return null;
        });

        function find_headers() {
            loading.value = true;
            axios.get("/organizationalCharts/header", {params: {getImage: false}}).then((response) => {
                organizational_charts.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function find_all() {
            loading.value = true;
            axios.get("/organizationalCharts").then((response) => {
                all_records.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            dialog.value = false;
            emit("input", active.value.length > 0 ? active.value[0].id : null);
            emit("changed");
        }

        function clear() {
            active.value = [];
            emit("input", null);
        }

        onMounted(() => {
            find_headers();
            find_all();
        });

        return {
            inputColor,
            backgroundColor,
            loading,
            dialog,
            organizational_chart,
            organizational_charts,
            all_records,
            active,
            open,
            selected,
            label_text,
            save,
            clear,
        }
    }
};
</script>